/**
 * Traducciones transversales: lo que usan los componentes del sistema de
 * diseño y varias pantallas a la vez.
 */
export const commonEn: Record<string, string> = {
  // Direcciones guardadas y primeros pasos (28-ago)
  "Mis direcciones de envío": "My shipping addresses",
  "Añadir mi dirección": "Add my address",
  "Añadir otra": "Add another",
  Predeterminada: "Default",
  "Usar por defecto": "Make default",
  "Guarda tu dirección y tus compras la traen ya escrita.":
    "Save your address and your orders will come with it filled in.",
  "Nueva dirección": "New address",
  "Editar dirección": "Edit address",
  "Escribe tu dirección": "Type your address",
  "Escribirla a mano": "Type it manually",
  "Etiqueta (opcional)": "Label (optional)",
  "Casa, Oficina…": "Home, Office…",
  "Guardar dirección": "Save address",
  "Llegaste al máximo de {{n}} direcciones. Borra una para añadir otra.":
    "You reached the limit of {{n}} addresses. Delete one to add another.",
  "Tus primeros pasos": "Your first steps",
  KYC: "KYC",
  Direcciones: "Addresses",
  "Compra o invita a alguien": "Buy or invite someone",
  "{{paso}}: cumplido": "{{paso}}: done",
  "{{paso}}: pendiente": "{{paso}}: pending",
  "Te faltan pasos para arrancar": "You still have steps to get started",
  "¡Felicidades! Ya eres parte de la familia It's The Best":
    "Congratulations! You're now part of the It's The Best family",
  "Completaste tus primeros pasos. Tu cuenta está lista para crecer: comparte tu enlace y empieza a construir tu red.":
    "You completed your first steps. Your account is ready to grow: share your link and start building your network.",
  "Ir a mi red": "Go to my network",
  Listo: "Done",
  "Solo lectura": "Read only",
  "¿Cómo funciona esta sección?": "How does this section work?",
  Confirmar: "Confirm",
  Cancelar: "Cancel",
  Cerrar: "Close",
  Reintentar: "Retry",
  Comenzar: "Get started",
  Guardar: "Save",
  Editar: "Edit",
  Eliminar: "Delete",
  Buscar: "Search",
  Cargando: "Loading",
  Siguiente: "Next",
  Atrás: "Back",

  /*
   * ── Armazón de la aplicación ──────────────────────────────────────
   *
   * El cromo de la barra lateral y la superior. Va AQUÍ y no en
   * `shop.ts` ni en `admin.ts` porque no es de nadie en particular: es
   * lo que envuelve a todas las pantallas con sesión.
   *
   * OJO con los duplicados: `resources.ts` funde common + shop + admin en
   * un solo mapa y este archivo se extiende PRIMERO, así que una clave
   * repetida más abajo GANA sobre la de aquí. Por eso las que la tienda o
   * el panel ya traducen NO se repiten: "Productos" y "Tienda" las tiene
   * `admin.ts`/`shop.ts`, e "Iniciar sesión", "Crear cuenta" y
   * "Navegación" las tiene `shop.ts`. La barra lateral las hereda tal
   * cual, y así el día que se cambie una redacción no quedan dos.
   */
  // Marca y secciones
  "It's The Best": "It's The Best",
  Panel: "Panel",
  Administración: "Administration",
  Sistema: "System",
  "Pantallas públicas": "Public screens",
  "Viven fuera del panel y traen su propio cromo.":
    "They live outside the panel and bring their own chrome.",
  "Estado del sistema": "System status",
  Acceso: "Sign in",

  // Barra lateral
  "Barra lateral": "Sidebar",
  "Navegación principal": "Main navigation",
  "Plegar la barra lateral": "Collapse sidebar",
  "Desplegar la barra lateral": "Expand sidebar",
  "Abrir la navegación": "Open navigation",
  "Cerrar navegación": "Close navigation",
  "Sesión no iniciada": "Not signed in",

  // Barra superior
  Idioma: "Language",
  Cuenta: "Account",
  "Cerrar sesión": "Sign out",

  /*
   * Notificaciones. El contador va DENTRO del nombre accesible del botón
   * —no en un texto aparte— porque el inglés no lo coloca donde el
   * español: separar el número de su frase es cómo se acaba leyendo
   * "Notifications 3 unread" en un idioma y algo peor en el otro.
   *
   * Las dos frases con número están redactadas para valer en SINGULAR y
   * en plural ("…, 1 sin leer", "Novedades sin leer: 1"). Con las claves
   * en español y el mapa `es` vacío, una variante `_one` solo arreglaría
   * el inglés: el español se pinta siempre tal cual está escrita la
   * clave.
   */
  Notificaciones: "Notifications",
  "Notificaciones, {{count}} sin leer": "Notifications, {{count}} unread",
  "No hay novedades": "Nothing new",
  "Cuando pase algo en tu cuenta, te enteras aquí.":
    "When something happens in your account, you'll find out here.",
  "Sin leer": "Unread",

  /* ── Añadido el 1-sep: lo que veía un cliente en español ── */
  "Acciones de esta notificación": "Actions for this notification",
  "Cerrar acciones": "Close actions",
  "Cuenta activa": "Active account",
  "It's The Best · Bienestar que se nota": "It's The Best · Wellness you can see",
  "Mi negocio": "My business",
  "Mi panel": "My panel",
  "Vista del panel": "Panel view",
  "script": "script",
  "status": "status",
  "token": "token",
};
